function vcTemplate() {
    this.source = "vcTemplate";
    this.visual = null;
    this.vcgid = "";
    this.vcvid = -1;
    this.vcC = new vcCommon();
    this.vcVisual = new vcVisual();
    this.blid = -1;
    this.error = false;
    this.reset = false;
    this.dirty = false;
    this.resources = { "err_code": "Application Error!", "err_sub_default": "Please reload the page! If the error still exists please contact the support!" };
}


vcTemplate.prototype.initCalendar = function (obj) {
    /// <summary>
    /// This function inits a basic jquery-ui datepicker.
    /// </summary>
    
    obj.datepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, showOn: 'button', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true });
}

vcTemplate.prototype.initIntervalCalendar = function (from, to, limit, onSelect) {
    /// <summary>
    /// This function is used to connect two date calenders together.<br/>
    /// </summary>
    from.datepicker({
        changeMonth: true, changeYear: true,
        showButtonPanel: true, showOn: 'button', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true,
        onClose: function (selectedDate) { to.datepicker("option", limit, selectedDate); },
        onSelect: function () {
            onSelect();
        }
    });
};

vcTemplate.prototype.navigateDate = function (obj, interval) {
    /// <summary>
    /// This function increases the date of an date input field by the given interval.
    /// </summary>
    var dt = $.datepicker.parseDate('dd.mm.yy', obj.val());
    dt.setDate(dt.getDate() + interval);
    obj.datepicker('setDate', dt);
};

vcTemplate.prototype.showInfo = function (content, subcontent, bError) {
    /// <summary>
    /// This function extends the basic showMessage() function with optional subcontent and specific style..
    /// </summary>
    var me = this;
    try {
        if (content.length === 0) {
            me.visual.find('#info').hide();
            me.visual.find('#info div').removeClass('note').removeClass('error').hide();
            return true;
        }
        me.visual.find('#info').show();
        if (bError) {
            me.visual.find('#info div').removeClass('note').addClass('error').show();
            content = "<span class='main'>" + content + "</span><br/><span class='sub'>" + subcontent + "</span>";
            me.visual.find('#info div').html(content);
           
        } else {
            me.visual.find('#info div').removeClass('error').addClass('note').html(content).show();
        }
        me.specificInfoHandling(bError);
        return true;
    } catch (ex) { writeError('Master.showMessage', ex); return false; }
}

// ReSharper disable once UnusedParameter
vcTemplate.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function can optionally overwriten by visual - can be used for specific tag showing/hiding and so on. 
    /// </summary>
};


vcTemplate.prototype.getRandomIDContainerObj = function (objName, bShowLoadingIcon) {
    /// <summary>
    /// This function generates a simple div with a random suffix to the object name.<br/>
    /// Optionally, a loading icon get set as well.
    /// </summary>
    var me = this;
    try {
        var random = parseInt(Math.random() * 100000, 10);
        var container = $("<div>").attr("id", objName + random);
        if (bShowLoadingIcon) {
            container.html(me.vcC.getLoadingIcon());
        }
       
        return {"obj": container, "random":random, "prefix":objName}
    } catch (ex) {
        writeError(me.source + '.JS.getRandomIDContainerObj', ex);
        return null;
    }
};


vcTemplate.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    try {


        if (me.visual.find(filterObj + " .floatbox").length > 0) {   
            //we reset the counter for found entries
            me.visual.find(listItem).data('counter', 0);

            //we filter the optional tags we got from the vc-tags
            var filter = me.visual.find(filterObj).vcFilter("getFilter");

            if (filter !== null) {
                var counter;
                //first, we count how often we find the filter tags in every signal item
                for (var i = 0; i <= filter.length - 1; i++) {
                    if (filter[i].length > 0) {
                        me.visual.find(listItem + ":contains('" + filter[i] + "')")
                            .each(function() {
                                counter = parseInt($(this).data('counter'), 10);
                                if (isNaN(counter)) {
                                    counter = 0;
                                }
                                counter ++;
                                $(this).data('counter', counter);

                            });
                    }
                }
                //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
                //why? if we have several filter tags we have to find all of them in one single signal 
                me.visual.find(listItem)
                    .each(function() {
                        if (parseInt($(this).data("counter"), 10) === filter.length) {
                            $(this).addClass(classFound);
                        }
                    });
            } else {
                me.visual.find(listItem).addClass(classFound);
            }
        }
} catch (ex) {
        writeError(me.source + '.JS.setTagFilter', ex);
    }
};

vcTemplate.prototype.openAskDialog = function (caption, posUser, yes, no, canc) {
    /// <summary>
    /// This function opens a dialog popup for common validation usage.
    /// yes, no, cancel are functions which get executed 
    /// pos can add specific position settings eg: of: target! - fixes position to target
    /// </summary>
    var me = this;
    var posDefault;
    var pos;
    var canc1;
    try {
        caption += "";
        posDefault =  { my: 'top+20%', at: 'top', of: window };
        pos = $().extend({},posDefault, posUser );

        if (typeof (yes) === "undefined") {
             yes = function () { }
        }
        if (typeof (no) === "undefined") { no = function () { } }
        if (typeof (canc) === "undefined") { canc1 = function () { } } else {canc1 = canc}

        var d = $('<p>' + caption + '</p>').dialog({
            position: pos,
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "Yes": function () { yes(); d.dialog('close'); return true; },
                "No": function () { no(); d.dialog('close'); return false; },
                "Cancel": function () { canc1(); d.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });

        if (typeof (canc) === "undefined") {$('.saveDialog .ui-button-text:contains(CANCEL)').hide();}

        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return true;
    } catch (ex) { me.writeError('openAskDialog', ex); return false; }
};


vcTemplate.prototype.openInfoDialog = function (caption, posUser, ok) {
    /// <summary>
    /// This function opens a dialog popup for common validation usage.
    /// yes, no, cancel are functions which get executed 
    /// pos can add specific position settings eg: of: target! - fixes position to target
    /// </summary>
    var me = this;
    var posDefault;
    var pos;
    try {
        caption += "";
        posDefault = { my: 'top+20%', at: 'top', of: window };
        pos = $().extend({}, posDefault, posUser);

        if (typeof (ok) === "undefined") {
            ok = function () { }
        }

        var d = $('<p>' + caption + '</p>').dialog({
            position: pos,
            title: me.resources.dialogTitle, modal: true,
            buttons: {
                "OK": function () { ok(); d.dialog('close'); return true; }
               
            },
            dialogClass: 'saveDialog'
        });

        return d;
    } catch (ex) { me.writeError('openInfoDialog', ex); return false; }
};


vcTemplate.prototype.showMessage = function (content, bError) {
    var me = this;
    try {

        //console.info(this.callFunct.caller.name + " " + jQuery.now());

        if (bError === false) {

          

            me.showInfo(content, "", false);
        } else {
            me.error = true;
            if (typeof (me.resources.err_sub) === "undefined") {
                me.showInfo(content, me.resources.err_sub_default, true);
            } else {
                me.showInfo(content, me.resources.err_sub, true);
            }
        }
        return false;
    } catch (ex) {
        writeError(me.source+'.JS.showMessage', ex);
        return false;
    }
};


vcTemplate.prototype.writeError = function (source, ex) {
    var me = this;
    try {
       
        me.error = true;

        //console.info(this.callFunct.caller.name + " " + jQuery.now());


        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};


vcTemplate.prototype.showDevIcon = function (img) {
    /// <summary>
    /// This function adds an icon for showing the development state (dev, beta, new) at the left top corner of a widget - hopefully.
    /// </summary>
    var me = this;
    try {
        if (img.length === 0) {
            return "";
        }
        me.visual.append("<div style='position:absolute;top:-5px;left:-5px;width:36px;height:36px;'><img src='../../images/" + img + ".png' style='width:36px;height:36px' /></div>");
        
        return false;
    } catch (ex) {
        writeError(me.source + '.JS.showDevIcon', ex);
        return false;
    }
};

vcTemplate.prototype.getPopupSize = function (factorW, factorH) {
    /// <summary>
    /// This function gets the popup size for a full screen popup
    /// </summary>
    var me = this;
    try {
        var size = [];
        var h = 0;
        var w = 0;

        //get the windows height for our popup
        h = $(window).height();
        if (h === 0) {
            h = $(document).height();
            if (h === 0) { h = document.body.scrollHeight; }
        }

        w = parseInt($(window).width() * factorW);
        h = parseInt(h * factorH);

        size.push(w, h);
        return size;

    } catch (ex) {
        writeError(me.source + '.JS.getPopupSize', ex);
        return false;
    }
};
